
<div class="voucher-wrapper">
  <div class="nav-arrow left-arrow" *ngIf="index > 0">
    <button mat-icon-button (click)="navigate('prev')">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="arrow-label">
      {{ allData[index - 1]?.voucher_no}}
    </div>
  </div>

  <div class="nav-arrow right-arrow" *ngIf="index < allData.length - 1">
    <button mat-icon-button (click)="navigate('next')">
      <mat-icon>chevron_right</mat-icon>
    </button>
    <div class="arrow-label">
      {{ allData[index + 1]?.voucher_no}} 
    </div>
  </div>
</div>

<div class="voucher-container">
    <div class="company-details">
        <h2 class="company-name">{{ company_name }}</h2>
        <p class="company-address">{{ company_address }}</p>
      </div>

      <div class="voucher-info">
        <div class="voucher-title">{{ voucherData.voucher_name }}</div>
        <div class="voucher-meta">
          <span><strong>No:</strong> {{ voucherData.voucher_no }}</span>
          <span><strong>Date:</strong> {{ voucherData.date | date: 'dd-MMM-yyyy' }}</span>
        </div>
      </div>

    <table class="voucher-table">
      <thead>
        <tr>
          <th>Particulars</th>
          <th>Debit</th>
          <th>Credit</th>
        </tr>
      </thead>
      <tbody>
        <!-- Debit Entries -->
        <tr *ngFor="let item of data.view.dr">
          <td>{{ item.ledger_name }}</td>
          <td>{{ item.amount | number:'1.2-2' }}</td>
          <td></td>
        </tr>

        <tr *ngFor="let item of data.view.cr">
          <td>{{ item.ledger_name }}</td>
          <td></td>
          <td>{{ item.amount | number:'1.2-2' }}</td>
        </tr>

        <tr class="total-row">
          <td><strong>Total</strong></td>
          <td><strong>{{ getTotal(data.view.dr) | number:'1.2-2' }}</strong></td>
          <td><strong>{{ getTotal(data.view.cr) | number:'1.2-2' }}</strong></td>
        </tr>
      </tbody>
    </table>
    <div class="account-section">
      <strong>On Account of:</strong>
      <p>{{ data.view.narration }}</p>
    </div>
    <div *ngIf="data.view.is_posted == 1 && is_auditor" class="dialog-header">
      <div>
        <h2 class="company-name">Audit</h2>
      </div>
      <div class="auditform">
        <form>
          <div>
            <div>
              <mat-label class="font-bold">voucher found </mat-label>
            </div>
            <br>
            <mat-radio-group aria-label="Select an option" [(ngModel)]="audit" name="audit">
              <mat-radio-button class="ok" [value]=1>Ok</mat-radio-button>
              <mat-radio-button class="not_ok" [value]=2>Not Ok</mat-radio-button>
            </mat-radio-group>
          </div>
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Remark</mat-label>
            <input matInput name="remark" [(ngModel)]="remark" name="remark" placeholder="Enter Remark">
          </mat-form-field>
        </form>
      </div>
    </div>

    <div mat-dialog-actions>
        <button mat-button class="btn btn-success" (click)="posting()" *ngIf="data.view.is_posted !== 1 && approval_status==true">Post</button>
        <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
      <button mat-button class="btn btn-primary create-button" (click)="posting()"
        *ngIf="data.view.is_posted !== 1 && data.view.approval_status=='Approved'">Post</button>
        <button mat-button class="btn btn-primary create-button" (click)="duplicateVoucher(data)" *ngIf="duplicate_btn">Duplicate</button>
      <button *ngIf="data.view.is_posted == 1 && is_auditor" mat-button class="btn btn-primary create-button"
        (click)="onSave(auditForm)">Save</button>
      <!-- <button mat-button class="btn btn-danger" style="height: 45px;font-size: 16px;" mat-dialog-close>Cancel</button> -->
    </div>

     <div class="signature-section">
        <p><strong>Authorized Signature</strong></p>
      </div>  
  </div>
